import { rgbToHex, sixDigitHexColor } from "lib/Colors/colorUtils";

const HEX_RE = /^#?(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

/**
 * Display text for a color swatch tooltip. Hex is normalized to uppercase
 * 6-digit (#RRGGBB), "transparent" becomes "Transparent", rgb()/rgba() is
 * converted to hex, and anything unrecognized is returned trimmed as-is.
 */
export const formatColorTooltip = (color?: string | null): string => {
  if (!color) return "";

  const trimmed = color.trim();

  if (/^transparent$/i.test(trimmed)) return "Transparent";

  if (/^rgba?\(/i.test(trimmed)) {
    const hex = rgbToHex(trimmed);
    return hex ? hex.toUpperCase() : trimmed;
  }

  if (HEX_RE.test(trimmed)) {
    const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
    return sixDigitHexColor(withHash);
  }

  return trimmed;
};
